module.exports = __webpack_public_path__ + "img/bg_scene_top.f9522336.png";